import { Rating } from '@fiverr-private/data_display';

export default Rating;
